import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { Monthly, StockReportHeading, Weekly, Yearly } from "../../../../utils/Constant";
import StockReportDetails from "./StockReportDetails";
import CommonStockReportChart from "./CommonStockReportChart";

const StockReport = () => {
  return (
    <Col lg="5" className="box-col-5">
      <Card>
        <CommonCardHeader headClass="pb-0" title={StockReportHeading} mainTitle={true} firstItem={Weekly} secondItem={Monthly} thirdItem={Yearly} />
        <CardBody className="p-0">
          <StockReportDetails />
          <CommonStockReportChart height={285}/>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StockReport;